import React from 'react';
import styled from 'styled-components';
import ListItem from './list-item';

const ListContainer = styled.div<{ overflow?: string }>`
  display: flex;
  flex-direction: column;
  overflow: ${(props) => props.overflow};
`;

type ListItemValue = string | Record<string, React.ReactNode>;

interface ListProps extends React.HTMLAttributes<HTMLDivElement> {
  items: ListItemValue[];
  labelField?: string;
  onDelete: (item: string) => void;
  overflow?: string;
}

const List = ({ items, labelField, onDelete, overflow, ...props }: ListProps): React.JSX.Element => (
  <ListContainer overflow={overflow} {...props}>
    {items.map((item) => {
      const label = typeof item === 'object' ? item[labelField as string] : item;
      return (
        <ListItem
          key={items.indexOf(item)}
          label={label}
          item={item as string}
          onDelete={onDelete}
        />
      );
    })}
  </ListContainer>
);

export default List;
